const subscriptionPlansEnglish = {
  header: {
    title: "Choose your plan",
    description: "Get access to all features and start increasing your LinkedIn presence today."
  },
  trial: {
    title: "14-day free trial",
    subtitle: "No commitment - cancel anytime"
  },
  billing: {
    monthly: "Monthly",
    yearly: "Yearly",
    savingsLabel: "Save 17%"
  },
  currency: {
    dkk: "DKK",
    usd: "USD"
  },
  plans: {
    basic: "Basic"
  },
  pricing: {
    perMonth: "month",
    perYear: "year",
    monthly: "month",
    yearly: "year"
  },
  quantity: {
    label: "Number of licenses:",
    seatsInfo: "Each license gives access to 1 user"
  },
  summary: {
    total: "Total:",
    checkoutButton: "Start free trial"
  },
  errors: {
    checkoutError: "An error occurred while creating checkout session. Please try again later."
  }
};

export default subscriptionPlansEnglish;
